import React from 'react';
import { suggestValidTemplateVariable } from 'services/forms';

export default function InvalidTemplateVariableWarning({ invalidVariable }) {
  const correction = suggestValidTemplateVariable(invalidVariable);

  if (!correction) return <div>Content has invalid template-variables</div>;

  return (
    <div>
      <div>
        <span style={{ color: 'red' }}>{invalidVariable}</span> is not a valid
        variable.
      </div>
      <div>
        Use <span style={{ color: 'green' }}>{correction}</span> instead
      </div>
    </div>
  );
}
